async function storeToken(uid: string, token: string): Promise<void> {
  try {
    await window.fetch(`${process.env.REACT_APP_API_GATEWAY_URL}/users/auth-tokens/${uid}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: token
      }),
    })
  } catch (error) {
    console.log(error);
  }
}

export default storeToken;
